var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-grow tw-max-h-full tw-h-full tw-pb-4"},[_c('v-row',{staticClass:"tw-max-h-full d-flex flex-row flex-grow-1",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"d-flex flex-column flex-grow-1 overflow-hidden"},[_c('kubiqa-activity')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }